import { render } from "./firebaseChat.vue?vue&type=template&id=1c877709&ts=true"
import script from "./firebaseChat.vue?vue&type=script&lang=ts"
export * from "./firebaseChat.vue?vue&type=script&lang=ts"

import "./firebaseChat.vue?vue&type=style&index=0&id=1c877709&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QScrollObserver from 'quasar/src/components/scroll-observer/QScrollObserver.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QSpinner,QScrollObserver,QBadge,QChatMessage,QIcon,QBtn});
